
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contactLensTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactLensTestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactLensTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactLensTestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactLensTestId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diopter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"radius"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLensObservation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLensSpherical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLensCylindrical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLensAxis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLensVisualAcuity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refractedSpherical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refractedCylindrical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refractedAxis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refractedVisualAcuity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finalSpherical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finalCylindrical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finalAxis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finalVisualAcuity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adapted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"material"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lens"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":620}};
    doc.loc.source = {"body":"query contactLensTest($contactLensTestId: ID!) {\n  contactLensTest(contactLensTestId: $contactLensTestId) {\n    id\n    updatedAt\n    eye\n    diopter\n    radius\n    diameter\n    contactLensObservation\n    contactLensSpherical\n    contactLensCylindrical\n    contactLensAxis\n    contactLensVisualAcuity\n    refractedSpherical\n    refractedCylindrical\n    refractedAxis\n    refractedVisualAcuity\n    finalSpherical\n    finalCylindrical\n    finalAxis\n    finalVisualAcuity\n    notes\n    adapted\n    material {\n      id\n      name\n    }\n    lens {\n      id\n      name\n      group {\n        id\n        name\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["contactLensTest"] = oneQuery(doc, "contactLensTest");
        
